<template>
  <div class="user-app-list-page w-100">
    <basic-subheader class="custom__basic-subheader">
      <template v-slot:filters>
        <b-row class="py-4">
          <b-col cols="12" class="d-flex justify-content-end">
            <b-button
              class="btn btn-success"
              type="button"
              @click="handleExport"
              :disabled="!selectedItems.length"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/File/file-text.svg" />
              </span>
              Xuất kết quả
            </b-button>

            <div class="d-flex justify-content-end align-items-center">
              <div style="margin-left: 10px"></div>
              <b-dropdown
                id="dropdown-right dropdown-form"
                class="dropdown-form-filter mr-2"
                no-caret
                right
                ref="dropdownFormFilter"
              >
                <template #button-content>
                  <span class="svg-icon">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/filter.svg"
                    />
                  </span>
                  Bộ lọc
                </template>
                <h6 class="d-flex align-items-center mb-0 p-4">
                  <span class="svg-icon mr-3">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/filter.svg"
                    />
                  </span>
                  Bộ lọc
                </h6>
                <b-dropdown-divider> </b-dropdown-divider>
                <b-dropdown-form :class="showNewCustomer ? 'mw-600' : 'mw-400'">
                  <b-container class="p-0">
                    <b-row>
                      <b-col>
                        <basic-input
                          label="Thông tin khách hàng"
                          placeholder="Nhập tên khách hàng"
                          name="Name"
                          :value.sync="filters.Name"
                         
                        ></basic-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <basic-input
                          label="Số điện thoại"
                          placeholder="Nhập số điện thoại"
                          name="PhoneNumber"
                          :value.sync="filters.PhoneNumber"
                        
                        ></basic-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <basic-select
                          label="Khảo sát"
                          placeholder="--- Chọn khảo sát ---"
                          name="status"
                          :solid="false"
                          :allowEmpty="true"
                          value-label="text"
                          track-by="value"
                          :options="surveys"
                          :value.sync="filters.survey"
                          changeValueByObject
                          class="mb-0"
                        ></basic-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group label="Thời gian hoàn thành" class="mb-0">
                          <date-picker
                            placeholder="Từ ngày"
                            name="startDate"
                            input-class="form-control"
                            type="date"
                            :format="dateFomartion"
                            value-type="format"
                            :disabled-date="disabledBeforeFromDate"
                            v-model="filters.startDate"
                            @change="selectDate('start', $event)"
                          ></date-picker>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group label="Thời gian hoàn thành" class="mb-0">
                          <date-picker
                            placeholder="Đến ngày"
                            name="endDate"
                            input-class="form-control"
                            type="date"
                            :format="dateFomartion"
                            value-type="format"
                            :disabled-date="disabledBeforeToDate"
                            v-model="filters.endDate"
                            @change="selectDate('end', $event)"
                          ></date-picker>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-dropdown-form>
                <b-dropdown-divider> </b-dropdown-divider>
                <div
                  class="d-flex align-items-center justify-content-lg-end m-0 p-4"
                >
                  <b-button
                    class="btn ml-2"
                    href="#"
                    tabindex="0"
                    @click="resetRequest"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                      />
                    </span>
                    Reset bộ lọc
                  </b-button>
                  <b-button
                    class="btn ml-2"
                    href="#"
                    tabindex="0"
                    @click="searchRequest"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/filter.svg"
                      />
                    </span>
                    Lọc dữ liệu
                  </b-button>
                </div>
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <!-- bộ lọc -->
      </template>
    </basic-subheader>
    <Wrapper>
      <template-table
        :column="column"
        :data="data"
        :paging="paging"
        :tableAction="false"
        :selectAction="true"
        :searchAction="false"
        @sortBy="sortRequest"
        @select="handleSelect"
      >
        <template v-slot:body="{ item }">
          <td>
            {{ item.fullName }}
          </td>
          <td>
            {{ item.phone ? item.phone.replace('+84', '0') : null }}
          </td>
          <td>
            <span v-if="item.accountType === 'Phone'" class="badge-login-type badge-phone">Phone</span>
            <span v-else-if="item.accountType === 'Zalo'" class="badge-login-type badge-zalo">Zalo</span>
            <span v-else-if="item.accountType === 'Google'" class="badge-login-type badge-google"><img src="/media/svg/logos/google-icon.svg" class="badge-google__icon" alt="" />Google</span>
          </td>
          <td>
            {{ item.surveyName }}
          </td>
          <td>
            {{ item.surveyCode }}
          </td>
          <td class="text-center">
            {{ item.answerCount }}
          </td>
          <td>
            {{ formatDate(item.lastDateDo) }}
          </td>
          <td style="width: 20px">
            <action-dropdown
              :value="item"
              :show_copy="false"
              :show_view="false"
              :show_edit="false"
              :show_delete="false"
              :boundary="data.length > 2 ? 'scrollParent' : 'window'"
              class="dropdown-form-filter"
            >
              <b-dropdown-text tag="div" class="navi-item cursor-pointer">
                <a class="navi-link cursor-pointer" @click="viewDetail(item)">
                  <span class="menu-icon svg-icon svg-icon-sm">
                    <inline-svg class="svg-icon" src="/media/svg/icons/Neolex/Basic/eye.svg" />
                  </span>
                  <span class="navi-text">Xem chi tiết</span>
                </a>
              </b-dropdown-text>
            </action-dropdown>
          </td>
        </template>
      </template-table>
    </Wrapper>
    <modal-survey-result-detail :item="detailItem" />
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { CHANGE_STATUS } from '@/core/services/store/survey.module';
const { mapActions } = createNamespacedHelpers('survey');
import DatePicker from 'vue2-datepicker';
import ModalSurveyResultDetail from './components/ModalSurveyResultDetail.vue';
export default {
  name: 'SurveyResultList',
  components: {
    'date-picker': DatePicker,
    'modal-survey-result-detail': ModalSurveyResultDetail,
  },
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      column: [
        {
          key: 'fullName',
          label: 'Khách hàng',
          sortable: true,
          style: {
            width: '20%',
          },
        },
        {
          key: 'phone',
          label: 'SĐT',
          sortable: false,
          style: {
            width: '150px',
          },
        },
        {
          key: 'accountType',
          label: 'Loại tài khoản',
          sortable: false,
          style: {
            width: '130px',
          },
        },
        {
          key: 'surveyName',
          label: 'Khảo sát',
          sortable: false,
        },
        {
          key: 'surveyCode',
          label: 'Mã khảo sát',
          sortable: false,
          style: {
            width: '150px',
          },
        },
        {
          key: 'answerCount',
          label: 'Số câu trả lời',
          sortable: false,
          style: {
            width: '120px',
          },
        },
        {
          key: 'lastDateDo',
          label: 'Lần làm gần nhất',
          sortable: true,
          style: {
            width: '170px',
          },
        },
        {
          key: 'action',
          label: '',
          sortable: false,
          style: {
            width: '20px',
          },
        },
      ],
      data: [],

      sort: {
        by: null,
        order: null,
      },
      filters: {
        startDate: null,
        endDate: null,
        status: null,
        package: null,
        survey: null,
        Name: null,
        PhoneNumber: null,
      },
      dateFomartion: 'DD/MM/YYYY',
      packages: [],
      surveys: [],
      selectedItems: [],
      filteredData: [],
      detailItem: null,
    };
  },

  computed: {
    searchParams() {
      return {
        Name: this.filters.Name,
        PhoneNumber: this.filters.PhoneNumber,
        orderBy: this.sort.by ? `${this.sort.by} ${this.sort.order}` : null,
        page: this.paging.page,
        size: this.paging.pageSize,
        surveyId: this.filters.survey?.value || null,
        // Hết ngày "Đến ngày", không thì mất các khảo sát làm trong chính ngày đó
        dateDoneTo: this.filters.endDate
          ? this.$moment(this.filters.endDate, 'DD/MM/YYYY')
              .endOf('date')
              .format('X')
          : null,
        dateDoneFrom: this.filters.startDate
          ? this.$moment(this.filters.startDate, 'DD/MM/YYYY')
              .startOf('date')
              .format('X')
          : null,
      };
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
    // Tên/SĐT chỉ lọc khi bấm "Lọc dữ liệu", tránh mỗi phím gõ một request
    'filters.survey'() {
      this.resetPaging();
    },
  },
  created() {
    this.loadData();
    this.getPrepareData();
  },
  methods: {
    ...mapActions({ CHANGE_STATUS }),
    async getPrepareData() {
      try {
        const { meta, data, error } = await this.$api.get(
          '/Survey/SurveyExtend',
        );
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
        this.packages =
          data?.package.map((el) => ({ text: el.name, value: el.id })) || [];
        this.surveys =
          data?.survey.map((el) => ({ text: el.name, value: el.id })) || [];
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      }
    },
    resetRequest() {
      this.filters = {
        startDate: null,
        endDate: null,
        status: null,
        package: null,
        survey: null,
        Name: null,
        PhoneNumber: null,
      };
      this.resetPaging();
    },
    searchRequest() {
      this.resetPaging();
      this.$refs.dropdownFormFilter?.hide();
    },
    viewDetail(item) {
      this.detailItem = item;
      this.$nextTick(() => this.$bvModal.show('modal-survey-result-detail'));
    },
    // BE trả DateTime dạng unix timestamp (giây)
    formatDate(value) {
      return value ? this.convertTimestampToDate(value, 'DD/MM/YYYY HH:mm') : null;
    },

    async loadData() {
      this.$store.commit('context/setLoading', true);
      try {
        const { meta, data, error } = await this.$api.get(
          '/Survey/SurveyResultUsers',
          {
            params: this.searchParams,
          },
        );

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
        this.data = data || [];
        this.paging.total = meta.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    sortRequest(val) {
      this.sort.by = val.column;
      this.sort.order = val.order;
      this.loadData();
    },
    resetPaging() {
      // Đang ở trang khác 1 thì watcher 'paging.page' tự gọi loadData
      if (this.paging.page !== 1) {
        this.paging.page = 1;
        return;
      }
      this.loadData();
    },
    disabledBeforeToDate(date) {
      if (this.filters.startDate) {
        const newDate = this.convertToISODate(this.filters.startDate);
        const deadline = new Date(newDate);
        deadline.setHours(0, 0, 0, 0);

        return date < deadline;
      }
    },
    disabledBeforeFromDate(date) {
      if (this.filters.endDate) {
        const newDate = this.convertToISODate(this.filters.endDate);
        const deadline = new Date(newDate);
        deadline.setHours(0, 0, 0, 0);

        return date > deadline;
      }
    },
    selectDate(type, date) {
      if (date) {
        if (type === 'start') {
          this.filters.startDate = date;
        } else {
          this.filters.endDate = date;
        }
      } else {
        if (type === 'start') {
          this.filters.startDate = null;
        } else {
          this.filters.endDate = null;
        }
      }
      this.resetPaging();
    },
    handleSelect(selectedItems) {
      this.selectedItems = selectedItems;
    },
    getFileName(string) {
      const match = string && string.match(/filename=([^;]+)/);
      return match ? match[1].replace(/"/g, '') : 'KetQuaKhaoSat.xlsx';
    },
    async handleExport() {
      this.$store.commit('context/setLoading', true);
      // Mỗi dòng là một cặp khách + khảo sát; BE gom theo khách, mỗi khách một sheet
      const params = this.selectedItems.map((el) => ({
        accountId: el.accountId,
        surveyId: el.surveyId,
      }));

      this.$api
        .post('/Survey/SurveyResultExport', params, {
          responseType: 'blob',
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `${this.getFileName(res.headers['content-disposition'])}`,
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          this.$toastr.e({
            title: 'Lỗi !',
            msg: 'Xuất kết quả lỗi',
          });
        })
        .finally(() => {
          this.$store.commit('context/setLoading', false);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// Cùng kiểu badge Zalo/Google bên màn Tiếp nhận
.badge-login-type {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 3px;
  vertical-align: middle;
  white-space: nowrap;
}

.badge-phone {
  background: #e6f6ed;
  color: #21a567;
}

.badge-zalo {
  background: #0068ff;
  color: #fff;
  letter-spacing: 0.02em;
}

.badge-google {
  background: #fff;
  color: #3c4043;
  border: 1px solid #dadce0;
  font-weight: 600;

  &__icon {
    width: 11px;
    height: 11px;
    margin-right: 4px;
  }
}

.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 96px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }

  &.draft {
    background: #888c9f;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom__basic-subheader {
  display: block;
  justify-content: unset;
  align-items: unset;
}
.tab-active {
  background-color: #fff !important;
  border: 1px solid #01645a;
}
</style>

<style lang="scss" scoped>
.wrap-icon {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-content: center;
  background: #e4f5f5;
  border-radius: 8px;
}

.wrap__tabs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 25px;

  .tab {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    cursor: pointer;

    &.tab__active {
      border: 1.5px solid #fdb913;
    }
  }
}

.wrap-icon-calender {
  background: #e6f6ed;
}
.wrap-icon-card {
  background: #fff7c0;
}
.wrap-icon-group {
  background: #feeddc;
}

.wrap-title {
  h5 {
    text-align: left;
  }

  div {
    color: #000;
    text-align: left;
  }
}
.mw-400 {
  min-width: 400px;
}
.mw-600 {
  min-width: 600px;
}
</style>
